import React from 'react';

import * as Yup from 'yup';
import { TextField } from '@material-ui/core';
import { BsChatSquareText, BsDpad, BsImage } from 'react-icons/bs';
import ImageInput from './ImageInput';
import ImageContent from './ImageContent';
import TemplateInput from './TemplateInput';
import TemplateContent from './TemplateContent';

const definitions = {
  text: {
    value: { text: '' },
    validate: { text: Yup.string().required('Required') },
    renderInput: ({ fieldProps }) => (
      <TextField
        {...fieldProps('body.text', 'Content', '')}
        inputProps={{ maxLength: 256 }}
        multiline
        minRows={4}
        maxRows={4}
      />
    ),
    icon: BsChatSquareText,
    iconStyle: { paddingTop: 4 },
    renderMessage: ({ body }) => (
      <h3 className="vertical-timeline-element-title">{body.text}</h3>
    ),
  },
  image: {
    value: { image: '', imageUrl: '', imageContentType: '' },
    validate: {
      image: Yup.string().required('Required'),
      imageUrl: Yup.string().required('Required'),
      imageContentType: Yup.string(),
    },
    renderInput: ({ fieldProps }) => (
      <ImageInput {...fieldProps('body', 'Content', {})} />
    ),
    icon: BsImage,
    renderMessage: ({ body }) => <ImageContent data={body} />,
  },
  interaction: {
    value: { templateId: '', icon: '', name: '', title: '', type: '' },
    validate: {
      templateId: Yup.string().required('Required'),
      icon: Yup.string(),
      name: Yup.string(),
      title: Yup.string(),
      type: Yup.string(),
    },
    icon: BsDpad,
    renderInput: ({ fieldProps }) => (
      <TemplateInput {...fieldProps('body', 'Content', {})} />
    ),
    renderMessage: ({ body }) => <TemplateContent data={body} preview />,
  },
};

export default definitions;
export const types = ['text', 'image', 'interaction'];
